export default "__VITE_ASSET__Betff1KN8SfCalWbBR1Zkg__"